import { useMutation } from '@tanstack/react-query'

import { UpdateClienteService } from '@/features/clientes/services/update-cliente.service'
import { clienteKeys } from '@/features/clientes/utils'
import type { TCreateCadastrarClienteData } from '@/shared/interfaces/cliente.types'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'

export const useMutationAtualizarCliente = () => {
  return useMutation<unknown, AxiosErrorMap, TCreateCadastrarClienteData & { id: string }>({
    retry: false,
    mutationKey: clienteKeys.atualizar(),
    mutationFn: async (params) => {
      const response = await new UpdateClienteService().execute(params.id, params)
      return response
    },
  })
}
